import { ArrowForward } from '@mui/icons-material'
import { Box, Button, type SxProps, type Theme, Typography } from '@mui/material'

interface Props {
  name: string
  started: boolean
  onClick: () => void
  backgroundColor?: string
}

export const PriorityActivityCard = (props: Props): JSX.Element => {
  const backgroundColor = props.backgroundColor ?? 'var(--blue-500)'
  const useWhiteText = backgroundColor === 'var(--blue-500)'

  const styles: Record<string, SxProps<Theme>> = {
    card: {
      backgroundColor: props.backgroundColor ?? 'var(--blue-500)',
      width: '230px',
      height: '200px',
      borderRadius: '12px',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column'
    },
    button: [{
      backgroundColor: 'var(--white)',
      color: 'var(--grey-700)',
      marginTop: 'auto',
      padding: '12px 20px',
      textTransform: 'none',
      fontSize: '16px',
      fontWeight: '600'
    },
    {
      '&:hover': {
        backgroundColor: props.backgroundColor,
        color: useWhiteText ? 'white' : 'var(--grey-700)'
      }
    }]
  }

  return <Box data-testid='coreActivityCard' sx={styles.card}>
    <Typography variant='h3' color='var(--white)'>
      {props.name}
    </Typography>

    <Button
      data-testid='startActivityButton'
      sx={styles.button}
      onClick={props.onClick}
      endIcon={<ArrowForward />}
    >
      {props.started ? 'Review' : 'Start'} this Activity
    </Button>
  </Box>
}
